import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BrokerFilterComponent } from './components/scripts/brokerFilter.component';
import { AuthGuard } from '../authentication/services/auth.guard.service';
import { BrokerComponent } from './components/scripts/broker.component';


const brokersRoutes: Routes = [
 {
    path: 'brokers', component: BrokerFilterComponent,
    canActivate: [AuthGuard],
    data: {
      roles: ['Admin', 'BrokersManager', 'BrokersUser']
    },
    children: [
      {
        path: '',
        children: [
          {
            path: 'filter',
            component: BrokerFilterComponent,
            data: { preload: true }
          }
        ]
      }
    ]
 },
  {
    path: 'brokers/edit/:brokerId',
    component: BrokerComponent,
    data: {
      roles: ['Admin', 'BrokersManager', 'BrokersUser']
    },
  },
  {
    path: 'brokers/create',
    component: BrokerComponent,
    data: {
      roles: ['Admin', 'BrokersManager', 'BrokersUser']
    },
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(brokersRoutes)
  ],
  exports: [
    RouterModule
  ]
})

export class BrokersRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/brokers/brokers-routing.module.ts